export const environment = {
  production: false,
  hmr: false,
  title: 'stage Environment Heading',
  apiURL: 'https://ant-api-stage.broetchen.taxi/api/',
  mollieAuthRedirectUri: "https://ant-commander-stage.broetchen.taxi/settings",
  QrUrl: "https://ant-stage.broetchen.taxi",
};